import { memo, useCallback, useEffect, useRef, useState } from 'react';
import {
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

// @ts-ignore
import ReadMore from 'react-text-more-less';

export type ParagraphClampedProps = {
  numberOfLines: number;
  wrapperStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  moreLessStyle?: StyleProp<TextStyle>;
  seeMoreStyle?: StyleProp<TextStyle>;
  seeLessStyle?: StyleProp<TextStyle>;
  seeMoreText?: string;
  seeLessText?: string;
  animate?: boolean;
  children?: string;
};

export const ParagraphClamped = memo((props: ParagraphClampedProps) => {
  const flattenedStyle = StyleSheet.flatten(props.textStyle);
  const lineHeight = flattenedStyle.lineHeight ?? 18;
  const { numberOfLines } = props;
  const [collapsed, setCollapsed] = useState(true);

  const [text, setText] = useState<string>(
    typeof props.children === 'string' ? props.children : '',
  );

  const hiddenEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof props.children !== 'string') {
      if (__DEV__) {
        console.warn(
          'Only text children is supported for clamped paragraph on web.',
        );
      }
      if (!hiddenEl.current) return;
      setText(hiddenEl.current.innerText);
    }
  }, [props.children]);

  const onToggle = useCallback(() => {
    const selection = window.getSelection();
    if (!selection?.toString()) {
      setCollapsed(v => !v);
    }
  }, []);

  return (
    <View style={props.wrapperStyle}>
      <Text style={props.textStyle}>
        <ReadMore
          text={text}
          lessHeight={numberOfLines * lineHeight}
          collapsed={collapsed}
          showMoreElement={
            <Text style={props.textStyle}>
              {'... '}
              <Text
                style={props.seeMoreStyle ?? props.moreLessStyle}
                onPress={onToggle}
              >
                {props.seeMoreText ?? 'See more'}
              </Text>
            </Text>
          }
          showLessElement={
            <Text style={props.textStyle}>
              {' '}
              <Text
                style={props.seeLessStyle ?? props.moreLessStyle}
                onPress={onToggle}
              >
                {props.seeLessText ?? 'See less'}
              </Text>
            </Text>
          }
          onClick={onToggle}
        />
        {props.children != null && typeof props.children !== 'string' && (
          <div
            style={{
              display: 'none',
            }}
          >
            {props.children}
          </div>
        )}
      </Text>
    </View>
  );
});
